import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import classes from "./index.module.scss";
import p1 from "../../../../assets/img/landings/nextres/1.jpg";
import p2 from "../../../../assets/img/landings/nextres/2.jpg";
import p3 from "../../../../assets/img/landings/nextres/3.jpg";
import p4 from "../../../../assets/img/landings/nextres/4.jpg";
import p5 from "../../../../assets/img/landings/nextres/5.jpg";
import p6 from "../../../../assets/img/landings/nextres/6.jpg";
import ReactCompareImage from "react-compare-image";

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Carousel() {
  const Handle = () => <div className={classes.handle} />;
  return (
    <div>
      <Swiper
        navigation={true}
        pagination={{ clickable: true }}
        allowTouchMove={false}
        noSwiping={true}
        spaceBetween={32}
        speed={500}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        slidesPerView={1}
        className={classes.swiper}
      >
        <SwiperSlide>
          <ReactCompareImage
            leftImage={p1}
            rightImage={p2}
            sliderLineWidth={3}
            handle={<Handle />}
          />
        </SwiperSlide>
        <SwiperSlide>
          <ReactCompareImage
            leftImage={p3}
            rightImage={p4}
            sliderLineWidth={3}
            handle={<Handle />}
          />
        </SwiperSlide>
        <SwiperSlide>
          <ReactCompareImage
            leftImage={p5}
            rightImage={p6}
            sliderLineWidth={3}
            handle={<Handle />}
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
